import { SiteNav } from "@/components/marketing/SiteNav";
import { SiteFooter } from "@/components/marketing/SiteFooter";
import { CONTACT_EMAIL } from "@/data/site";

const SECTIONS = [
  ["Who we are", `Pulse Commissioning ([company legal name], [registered address]) is the controller of personal data collected through this website and the Pulse Commissioning application. Contact: ${CONTACT_EMAIL}.`],
  ["What we collect", "When you request a demo: your name, company, role, email address, industry, project type, approximate tag count and message. When you use the application: your name, email address, profile picture from your sign-in provider, and the records you create, including checksheets, photos, signatures and punch items."],
  ["Why we use it", "To respond to demo requests (legitimate interests), to provide the application under our contract with your organisation, and to keep an audit trail of changes as part of that service."],
  ["Where it is stored", "Data is hosted in the UK. We do not sell personal data. We share it only with processors that help us run the service, under written agreements."],
  ["How long we keep it", "Demo requests are kept for [retention period]. Project data is kept for the term of your organisation's subscription and then returned or deleted on request."],
  ["Your rights", "Under UK GDPR you can ask for access to, correction of, or deletion of your personal data, object to processing, and ask for data portability. You can also complain to the Information Commissioner's Office (ico.org.uk)."],
  ["Cookies", "The application uses a single essential session cookie to keep you signed in. The website does not use advertising cookies."],
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#080D1A]">
      <SiteNav />
      <main className="max-w-3xl mx-auto px-5 py-16 md:py-24" data-testid="privacy-page">
        <p className="eyebrow mb-4">Legal</p>
        <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-50">Privacy policy</h1>
        <p className="text-sm text-slate-500 mt-3 font-mono">Draft. Items in [brackets] to be completed before launch.</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map(([t, d]) => (
            <section key={t}>
              <h2 className="text-xl font-semibold text-slate-100 mb-2">{t}</h2>
              <p className="text-slate-400 leading-relaxed">{d}</p>
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
